import React, {
  Fragment,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./Mda.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getMDAForms } from "../../apis/mdaApi";
import { getDomain } from "../../utils/functions";
import { BASE_DOMAIN } from "../../utils/constants";
import { TailSpin } from "react-loader-spinner";

const DropdownList = forwardRef(
  (
    {
      isVisible = false,
      // setIsVisible,
      data,
      onClick,
      handleClose,
      container,
      setValue,
    },
    ref
  ) => {
    const [options, setOptions] = useState(data);

    const handleClick = (option) => {
      handleClose();
      onClick(option);
      setOptions(data);
      setValue(option.companyName);
      // setIsVisible(false); // Close the dropdown immediately after selecting an option
    };

    const globalListner = (e) => {
      if (
        container &&
        container.current &&
        container.current.contains(e.target)
      ) {
        return;
      }
      handleClose();
    };

    useEffect(() => {
      setOptions(data);
    }, [data]);

    useEffect(() => {
      document.addEventListener("click", globalListner);
      return () => {
        document.removeEventListener("click", globalListner);
      };
    }, []);

    if (!isVisible) return <></>;

    return (
      <div className={styles.dropdownList} ref={ref}>
        <div className={styles.dropdownListItemContainer}>
          {options &&
            options.length > 0 &&
            options.map((option, index) => (
              <Fragment key={`${option}-${index}`}>
                <button
                  className={styles.dropdownListItem}
                  type="button"
                  onClick={() => handleClick(option)}
                >
                  {option.companyName}
                </button>
              </Fragment>
            ))}
        </div>
      </div>
    );
  }
);

export default function Mda() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const param = state && state.param;
  const MDAList = state && state.param1;
  const email = state && state.param2;
  const accessToken = state && state.accessToken;
  const mdaRequester = state && state?.mda;

  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState();
  const [ticketValue, setTicketValue] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(param);
  const [searchQuery, setSearchQuery] = useState("");


  const [MDAForms, setMDAForms] = useState([]);
  const [filteredMDAForms, setFilteredMDAForms] = useState([]);
  const [meta, setMeta] = useState({
    totalCount: 0,
    currentPage: 1, // Initialize currentPage to 1
    pageCount: 10, // Assuming default pageCount
  });

  const inputRef = useRef();
  const dropdownRef = useRef();

  const handleProceed = () => {
    navigate("/track", {
      state: { param: selectedOption, param2: email, ticketId: ticketValue, param1: 'trackForm' },
    });
  };
  const openForm = (formName) => {
    navigate("/mdaform", {
      state: {
        selectedOption: selectedOption,
        email: email,
        formName: formName,
        accessToken: accessToken,
        mda: mdaRequester
      },
    });
  };

  // Access parameters from the state object

  const dropdownOptions = [
    { value: 20, label: "20" },
    { value: 10, label: "10" },
    { value: 5, label: "5" },
  ];

  const fetchMDAForms = async () => {
    setIsLoading(true);
    const result = await getMDAForms({
      token: selectedOption?.token,
      tenantId: selectedOption?.cicodnumber,
      accessToken: accessToken,
    });
    setMeta(result.data._meta);
    setMDAForms(result.data.data);
    setIsLoading(false);
    if (!result.ok) {
      console.log(result.originalError.message);
    } //  setStates(result.data.states);
  };


  useEffect(() => {
    setValue(param && param.companyName);
  }, [param]);

  useEffect(() => {
    fetchMDAForms();
  }, [value]);

  useEffect(() => {
    if (Array.isArray(MDAForms)) {
      setFilteredMDAForms(
        MDAForms.filter((form) =>
          form.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [MDAForms, searchQuery]);



  const handleInputSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  // Function to classify forms based on the queues' names
  const classifyFormsByQueue = (forms) => {
    const classifiedForms = [];

    forms.forEach((form) => {
      if (!form?.queueTypes) return;
      const queueName = form?.queueTypes[0].name;

      const existingQueue = classifiedForms.find(
        (item) => item.queueName === queueName
      );

      if (existingQueue) {
        existingQueue.forms.push(form);
      } else {
        const newQueue = {
          queueName,
          forms: [form],
        };
        classifiedForms.push(newQueue);
      }
    });
    return classifiedForms;
  };

  // Classify forms based on the queues' names
  const formsClassifiedByQueue = classifyFormsByQueue(filteredMDAForms);

  // Get the total number of forms per queue and add it to the queue object
  const formsClassifiedCountPerQueue = formsClassifiedByQueue.map((queue) => ({
    queueName: queue.queueName,
    formsCount: queue.forms.length,
  }));


  const goBack = () => {
    navigate(-1);
  };

  const handleInputChange = (event) => {
    setTicketValue(event.target.value);
  };

  const previousPage = () => {
    if (meta?.currentPage > 1) {
      const previousPageNumber = meta.currentPage - meta.pageCount;
      setMeta({ ...meta, currentPage: Math.max(previousPageNumber, 1) });
    }
  };

  const nextPage = () => {
    const nextPageNumber = meta.currentPage + meta.pageCount;
    setMeta({ ...meta, currentPage: nextPageNumber });
  };

  return (
    <div className={styles.container}>
      {/* Header Row */}
      <div className={styles.titleContainer}>
        <span className={styles.icon}>
          {" "}
          <img
            src="https://res.cloudinary.com/dso7hgghd/image/upload/v1705918242/back_no6tw3.png"
            width={26}
            alt="Go back"
            onClick={goBack}
          />

        </span>
        <span className={styles.title}>Inter MDA Request</span>
        {/* <div className={styles.iconContainer}>
          <span className={styles.icon}>
            {" "}
            <img
              src=" https://res.cloudinary.com/dso7hgghd/image/upload/v1705918372/info_fw4ton.svg"
              width={26}
              alt="info"
            />
          </span>
        </div> */}
      </div>

      <div className={styles.headerContainer}>
        <div className={styles.leftContainer}>
          <div className={styles.customSelect}>
            <div
              className={`${styles.inputContainer} ${styles.dropdownContainer}`}
            >
              <div ref={inputRef}>
                <input
                  type="text"
                  className={styles.input}
                  value={value}
                  onClick={() => setIsVisible(true)}
                />
                <span className={styles.caretIcon}>
                  <img
                    src=" https://res.cloudinary.com/dso7hgghd/image/upload/v1706419397/Icon_ionic-md-arrow-dropdown_zngpf1.png"
                    width={10}
                    alt=""
                  />
                </span>

                <DropdownList
                  ref={dropdownRef}
                  isVisible={isVisible}
                  handleClose={() => setIsVisible(false)}
                  container={inputRef}
                  data={MDAList}
                  onClick={(option) => {
                    setValue(option.companyName);
                    setSelectedOption(option);
                  }}
                  setValue={setValue}
                />
              </div>
            </div>
          </div>

          <div>
            <input
              type="text"
              placeholder="Search forms by name"
              className={styles.myInput}
              value={searchQuery}
              onChange={handleInputSearch}
            />
          </div>
        </div>
        <div className={styles.rightContainer}>
          <p className={styles.rightText}>Task ID</p>

          <input
            type="text"
            placeholder="Enter your task ID"
            className={styles.searchbox}
            value={ticketValue}
            onChange={handleInputChange}
          />
          <button
            className={styles.btn}
            onClick={handleProceed}
            disabled={email === null}
          >
            Track
          </button>
        </div>
      </div>


      <div className={styles.wrapper}>
        <div className={styles.formSection}>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <TailSpin color="#25734D" radius={"2px"} />
            </div>
          ) : formsClassifiedCountPerQueue.length === 0 ? (
            <p style={{ textAlign: "center" }}>
              There are no forms available here.
            </p>
          ) : (
            formsClassifiedCountPerQueue &&
            formsClassifiedCountPerQueue.map((queue) => (
              <div key={queue.queueName}>
                <header>
                  <h2 className={styles.header}>
                    {queue.queueName} - {queue.formsCount}{" "}
                    {queue.formsCount > 1 ? "FORMS" : "FORM"}
                  </h2>
                </header>

                <div className={styles.rowParent}>
                  <div className={styles.row}>
                    <div className={styles.body}>
                      {formsClassifiedByQueue
                        .find((item) => item.queueName === queue.queueName)
                        ?.forms?.map((form) => (
                          <div key={form.id}>
                            <p
                              onClick={() => openForm(form.name)}
                              className={styles.queue}
                            >
                              {form.name}
                            </p>

                            {/* <Link
                            to={`https://${selectedOption.tenantId}.${BASE_DOMAIN}/webform/${form.name}`}
                          >
                            <p className={styles.queue}>{form.name}</p>
                          </Link>  */}
                            {/* Uncomment the lines below if you want to display form descriptions */}
                            {/* <p className={styles.description}>
                        {form.description}
                      </p> */}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
     
          <img
            src="https://res.cloudinary.com/dso7hgghd/image/upload/v1707909679/iNTER-MDA_Request_io2019.svg"
            alt="Guide"
            style={{paddingRight:0}}
          />

      </div>

      {/* Pagination */}
      {/* <div className={styles.paginationContainer}>
        <span className={styles.pagesText}>PAGES</span>
        <select className={styles.pageDropdown}>
          {dropdownOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className={styles.pageNumbers}>
          <span>1 of {meta?.totalCount}</span>
        </div>

        <div className={styles.paginationArrow} onClick={previousPage}>
          <img
            src="https://res.cloudinary.com/dso7hgghd/image/upload/v1706800524/left_oxhn34.png"
            width={8}
            alt="Previous Page"
            // onClick={goBack}
          />
        </div>
        <div className={styles.numContainer}>
          <span className={styles.num}>{meta?.currentPage}</span>
        </div>

        <div className={styles.paginationArrow} onClick={nextPage}>
          <img
            src="https://res.cloudinary.com/dso7hgghd/image/upload/v1706800456/right_cmxesv.png"
            width={8}
            alt="Next Page"
          />
        </div>
      </div> */}
    </div>
  );
}
